import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'groupBy'
})
export class GroupByPipe implements PipeTransform {
  transform(array: any[], key: string, expandedKey?: any): any[] {
    if (!array || !Array.isArray(array)) return [];

    const grouped = array.reduce((acc, item) => {
      const groupKey = item && item[key] !== undefined ? item[key] : 'undefined';
      if (!acc[groupKey]) {
        acc[groupKey] = {
          key: groupKey,
          items: [],
          expanded: expandedKey != null && groupKey === expandedKey
        };
      }
      acc[groupKey].items.push(item);
      return acc;
    }, {});
    return Object.values(grouped);
  }
}
